import { compose } from 'react-apollo';
import {withRouter} from 'react-router';

import LeadsPage from './LeadsPage';


export default compose(
  withRouter,

)(LeadsPage);